var React = require('react');

function Redlocation (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"fill":"#E04646","d":"M5.431,0C2.436,0,0,2.436,0,5.431c0,1.185,0.374,2.311,1.083,3.256l4.013,5.404\r\n\t\t\tc0.01,0.013,0.025,0.018,0.036,0.03c0.201,0.215,0.49,0.161,0.633-0.03c1.155-1.542,3.273-4.421,4.088-5.507l0.001-0.001\r\n\t\t\tl0.005-0.007c0.656-0.922,1.003-2.009,1.003-3.144C10.861,2.436,8.425,0,5.431,0z M5.431,8.36c-1.612,0-2.93-1.318-2.93-2.93\r\n\t\t\ts1.318-2.93,2.93-2.93s2.93,1.318,2.93,2.93S7.043,8.36,5.431,8.36z"}))));
}

Redlocation.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"10.861px","height":"14.259px","viewBox":"0 0 10.861 14.259","enableBackground":"new 0 0 10.861 14.259","xmlSpace":"preserve"};

module.exports = Redlocation;

Redlocation.default = Redlocation;
